<template>
  <v-app class="w-100">
    <!-- メインコンテンツ -->
    <v-main class="background-bg d-flex justify-center mx-0 w-100">
      <div class="contents-max-width w-100 h-100" :class="addBorderClassIfNecessary()">
        <slot />
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify';

const { width } = useDisplay();
/**
 * 画面幅がタブレット端末以上の場合はコンテンツの幅に合わせて枠線を引く
 */
const addBorderClassIfNecessary = () => {
  if (width.value > 1024) {
    return 'border-s-md border-e-md';
  }
};
</script>

<style lang="scss" scoped>
@use '~/assets/scss/_base.scss' as vars;

.background-bg {
  background-color: vars.$color-background;
}

.contents-max-width {
  max-width: vars.$content-max-width;
}
</style>
